import {
    blue,
    cyan,
    geekblue,
    gold,
    green,
    lime,
    magenta,
    orange,
    purple,
    red,
    volcano,
    yellow,
} from '@ant-design/colors';
import Axios from 'axios';

import ls from 'local-storage';

const LEGACY_FOLDERS_STORAGE_KEY = 'nw_config_openfolders';

//prima del passaggio all'esadecimale il colore era il nome di un preset Ant Design
const LEGACY_FOLDER_COLORS = {
    pink: magenta[5],
    magenta: magenta[5],
    red: red[5],
    volcano: volcano[5],
    orange: orange[5],
    gold: gold[5],
    yellow: yellow[5],
    lime: lime[5],
    green: green[5],
    cyan: cyan[5],
    blue: blue[5],
    geekblue: geekblue[5],
    purple: purple[5],
};

const DEFAULT_FOLDER_COLOR = magenta[5];

//il colore e' salvato senza cancelletto: si normalizza per CSS e componenti Ant Design
const getFolderColor = (color) => {
    if (!color) {
        return DEFAULT_FOLDER_COLOR;
    }
    if (LEGACY_FOLDER_COLORS[color]) {
        return LEGACY_FOLDER_COLORS[color];
    }
    return color.startsWith('#') ? color : `#${color}`;
};

//il backend vuole l'esadecimale senza cancelletto
const getFolderColorPayload = (color) => getFolderColor(color).replace('#', '');

//le folder rileggono la privacy da PrivacyLevel, non da PrivacyLevelName come books, playlist e travel plan
const isPrivateFolder = (folder) => {
    return folder ? folder.PrivacyLevel === 'User' : false;
};

const getFolderContacts = (folder) => {
    return folder && folder.ContactIDs ? folder.ContactIDs : [];
};

//il backend restituisce il tipo in PascalCase ("Model"), la GUI usa itemType minuscolo
const isFolderOfType = (folder, itemType) => {
    return folder && folder.Type ? folder.Type.toLowerCase() === String(itemType).toLowerCase() : false;
};

const saveLegacyFoldersConfiguration = (openFolders) => {
    return Axios.post('/userclientconfigurations', {
        Name: 'folders',
        JsonData: JSON.stringify({ openFolders: openFolders }),
    });
};

/**
 * Migrazione una tantum delle folder salvate nella configurazione utente.
 * Le folder legacy sono personali, quindi diventano folder di database con PrivacyLevel "User".
 * Quelle che falliscono restano nella configurazione e si ritentano al login successivo.
 * Ritorna il numero di folder create.
 */
const migrateLegacyFolders = async (legacyFolders) => {
    //la copia locale non viene piu' letta da nessuno: si rimuove sempre
    ls.remove(LEGACY_FOLDERS_STORAGE_KEY);

    if (!legacyFolders || legacyFolders.length === 0) {
        return 0;
    }

    const notMigrated = [];
    for (const legacyFolder of legacyFolders) {
        try {
            await Axios.post('/folders', {
                Name: legacyFolder.title,
                Description: '',
                Type: legacyFolder.type,
                Color: getFolderColorPayload(legacyFolder.color),
                PrivacyLevel: 'User',
                ContactIDs: legacyFolder.items || [],
            });
        } catch (error) {
            console.error('Migrate Legacy Folder Error => ', error);
            notMigrated.push(legacyFolder);
        }
    }

    try {
        await saveLegacyFoldersConfiguration(notMigrated);
    } catch (error) {
        console.error('Clear Legacy Folders Configuration Error => ', error);
    }

    return legacyFolders.length - notMigrated.length;
};

export {
    DEFAULT_FOLDER_COLOR,
    getFolderColor,
    getFolderColorPayload,
    getFolderContacts,
    isFolderOfType,
    isPrivateFolder,
    migrateLegacyFolders,
};
